import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { Waves } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 mt-24 bg-[#050A15]">
      <div className="mx-auto max-w-7xl px-6 py-12 grid gap-8 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <span className="grid place-items-center h-8 w-8 rounded-sm bg-gradient-to-br from-[#8A2BE2] via-[#00FFFF] to-[#00FF7F]">
              <Waves className="h-4 w-4 text-[#050A15]" strokeWidth={2.5} />
            </span>
            <span className="font-display font-bold text-lg">Quantum<span className="qs-grad-text">Spectra</span></span>
          </div>
          <p className="text-sm text-slate-400 max-w-md leading-relaxed">{t("footer_note")}</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-widest text-slate-500 mb-3">Platform</p>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/architecture" data-testid="footer-architecture" className="hover:text-[#00FFFF]">Platform architecture</Link></li>
            <li><Link to="/pitch" data-testid="footer-pitch" className="hover:text-[#00FFFF]">Investor one-pager</Link></li>
            <li><Link to="/twin" data-testid="footer-twin" className="hover:text-[#00FFFF]">Urban Digital Twin (demo)</Link></li>
            <li><Link to="/disaster" data-testid="footer-disaster" className="hover:text-[#00FFFF]">Disaster Governance (3D terrain)</Link></li>
            <li><Link to="/registry" className="hover:text-[#00FFFF]">Safety Registry</Link></li>
            <li><Link to="/marketplace" className="hover:text-[#00FFFF]">Financing</Link></li>
            <li><Link to="/ledger" className="hover:text-[#00FFFF]">Rent Ledger</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-widest text-slate-500 mb-3">Academic</p>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>Başkent University</li>
            <li>TBDY 2018 · Eurocode 8</li>
            <li>Copernicus · USGS</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-slate-600 font-mono">
        © 2026 QuantumSpectra · Hyperspectral × Quantum × Blockchain
      </div>
    </footer>
  );
};
